import React from 'react'
import { Link } from 'react-router-dom'
import { jewellerydata } from '../DUMMYDATA/DUMMYDATA'

const ProductList = () => {

  const scrollToTop = ()=>{
    window.scrollTo({
      top: 0,
      behavior: 'smooth', 
    });
  } 

  const itemcount = 4;
  return (
    <>
        {jewellerydata.map((data)=>(
            <div key={data.category} id={data.category.toLowerCase()}  className='w-full py-9 cursor-pointer'>
                <h3 className='text-center text-[26px] font-bold text-tertary2 mb-10'>{data.category}</h3>
                <div className='flex flex-wrap justify-evenly'>
                {data.items.slice(0,itemcount).map((product) => (
                  <div key={product.id} className='flex flex-col md:px-[29px] mb-8 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                    <img className='w-[300px] rounded-3xl' src={product.img} alt='' />
                    <div className='flex flex-col shadow-md rounded-3xl'>
                      <h3 className='text-center text-[13px] font-medium mt-2 text-tertary2'>{product.name}</h3>
                      <p className='text-center text-[13px] pt-1 pb-4'>{product.material}</p>
                    </div>
                  </div>
                ))}       
                
                </div>
                <div className='text-center mt-4 '>
                 <Link to={`/category-detail/${data.category.toLowerCase()}`} onClick={scrollToTop}> <button className='mt-4 bg-tertary2 hover:bg-gold text-white font-bold py-2 px-4 rounded-md'>View more</button> </Link>
                </div>
            </div>
            
        ))}
         
    </>
  )
}

export default ProductList